"use client";

import React from "react";
import { Twitter, Linkedin, Github } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="234711" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 w-full">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-3">
            <div className="h-4 w-24 bg-muted/30 animate-pulse rounded-md" />
            <div className="h-4 w-32 bg-muted/30 animate-pulse rounded-md" />
            <div className="h-4 w-20 bg-muted/30 animate-pulse rounded-md" />
          </div>)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="max-w-full w-full items-start justify-start">
      <NavigationMenuList className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-4 w-full items-start justify-start flex-none">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start text-foreground/70 hover:text-primary hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent px-0 py-1 transition-colors duration-300 font-default text-lg">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const siteTitle = "TRAVEL";
  return <footer className="bg-background border-t border-border py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-4 flex flex-col gap-6">
            <Link to="/">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-muted-foreground text-lg max-w-sm">
              Fedezze fel a világot velünk. Prémium utazási élmények, szállások és foglalások egy helyen.
            </p>
            <div className="flex gap-4">
              <Button variant="ghost" size="icon" className="rounded-lg hover:text-primary transition-colors">
                <Twitter className="size-5" />
              </Button>
              <Button variant="ghost" size="icon" className="rounded-lg hover:text-primary transition-colors">
                <Linkedin className="size-5" />
              </Button>
              <Button variant="ghost" size="icon" className="rounded-lg hover:text-primary transition-colors">
                <Github className="size-5" />
              </Button>
            </div>
          </div>

          <div className="lg:col-span-8">
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <p className="text-muted-foreground text-sm">
              © {currentYear} {siteTitle}. Minden jog fenntartva.
            </p>
          </div>
          
          <div className="flex gap-6">
            <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">Adatvédelem</Link>
            <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">Általános Szerződési Feltételek</Link>
          </div>
        </div>
      </div>
    </footer>;
}